import styled, { css } from 'styled-components'
import { shimmerAnim } from '../../../utils'

type StyledProps = {
  $complete?: boolean
  $loading?: boolean
}

const StyledLessonButton = styled.button<StyledProps>`
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  justify-content: space-between;
  height: 50px;
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 20px;
  font-weight: 500;
  transition: 0.2s;
  background-color: ${({ theme }) => theme.color.green[700]};
  color: ${({ theme }) => theme.color.background};
  box-shadow: 0 2px 2px rgb(0, 0, 0, 0.1), 0 2px 10px rgb(0, 0, 0, 0.1);

  .text-anim {
    position: absolute;
    width: 100%;
    top: 0;
    height: 100%;
    left: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    transition: top 0.15s ease-in-out, opacity 0.15s ease-in-out;

    &.completed-text {
      top: 0;
    }

    &.uncomplete-text {
      top: 100%;
      opacity: 0;
    }
  }

  svg {
    height: 24px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.green[800]};
    box-shadow: 0 2px 2px rgb(0, 0, 0, 0.1), 0 2px 10px rgb(0, 0, 0, 0.1);

    .text-anim {
      &.completed-text {
        top: -100%;
        opacity: 0;
      }

      &.uncomplete-text {
        top: 0;
        opacity: 1;
      }
    }
  }

  &:active {
    transform: scale(0.98);
  }

  ${({ $complete, theme }) =>
    $complete &&
    `
    box-shadow: none;
    background-color: ${theme.color.green[400]}40;
    color: ${theme.color.green[800]};

    &:hover {
      color: ${theme.color.background};
      background-color: ${theme.color.red[800]};
    }
  `}

  ${({ $loading }) =>
    $loading &&
    css`
      pointer-events: none;
      box-shadow: none;
      animation: ${shimmerAnim} 1.4s ease-in-out infinite;
    `}
`

export default StyledLessonButton
